<template>
  <li>
    <v-icon class="drag__icon">drag_indicator</v-icon>
    <v-text-field
      :label="$t('components.formMCQ.fields.responses.label.name')"
      v-model="response.text"
      color="valid"
    />
    <v-btn class="app__btn__delete"
           min-width="35"
           height="35"
           color="cancel"
           @click="$emit('remove-response', response.id)"
    >
      <v-icon>close</v-icon>
    </v-btn>
  </li>
</template>

<script>
export default {
  name: 'formMCQResponseItem',
  props: {
    responseInit: {
      required: true,
      type: Object
    }
  },
  data: () => {
    return {
      /**
       * @type {MCQResponseAir}
       */
      response: {}
    }
  },
  beforeMount () {
    this.response = this.responseInit
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppButtonErnest";

  li {
    display: flex;
    margin-left: 20px;
    align-items: center;

    .drag__icon {
      cursor: grab;
      margin-right: 10px;

      &:active {
        cursor: grabbing;
      }
    }
  }
</style>
